// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ndrxp","rootNoMargin":"styles_rootNoMargin__3KYTp"};